import { DxChartTitleSubtitle } from 'devextreme-vue/chart';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	{
		path: '/',
		name: 'home',
		component: () => import('@/views/Home.vue'),
	},
	{
		path: '/charts/create',
		name: 'charts.create',
		component: () => import('@/views/charts/ChartCreate.vue')
	},
	{
		path: '/charts/create/multiple',
		name: 'charts.create.multiple',
		component: () => import('@/views/charts/ChartCreateMultiple.vue')
	},
	{
		name: 'authCallback',
		path: '/authCallback',
		//component: () => import('@/views/AuthCallback.vue'),
		component: () => import('@step/auth/src/auth/views/AuthCallback.vue'),
		meta: {
			layout: 'none'
		}
	},
	{
		name: 'dashboardReadOnly',
		path: '/dashboardReadOnly/:id',
		component: () => import('@/views/dashboard/DashboardReadOnly.vue'),
		props: true
	}

];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
